// eslint-disable-next-line object-curly-newline
import {
  getRandomInt,
  paginateArray,
  randomDate,
  sortCompare,
} from "@/@fake-db/utils";

import mock from "@/@fake-db/mock";

const nextDay = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
const nextWeek = new Date(nextDay.getTime() + 7 * 24 * 60 * 60 * 1000);

/* eslint-disable global-require */
const db = {
  orders: [
    {
      id: "f214251e-13c3-4656-b193-1664ac25bc03",
      order_id: 366,
      products: [
        {
          id: 6,
          name: "Thuốc Distocide 600mg Shinpoong Daewoo điều trị sán (4 viên)",
          slug: "thuoc-distocide-600mg-shinpoong-daewoo-djieu-tri-san-4-vien-6",
          description:
            "Distocide 600 Mg của Công ty TNHH Dược phẩm SHINPOONG DAEWOO có thành phần chính là praziquantel 600 mg. Thuốc được sử dụng để điều trị sán máng, sán lá gan nhỏ , sán phổi Paragonimus, sán Opisthorchis, các loại sán lá khác, sán dây, ấu trùng sán ở não. Distocide 600 Mg được bào chế dưới dạng viên nén bao phim, màu trắng, dài. Quy cách đóng gói là hộp 1 vỉ nhôm – PVC x 4 viên.",
          brand: "SHINPOONG",
          price: 34000,
          old_price: 0,
          image: "/img/2.8a01fd23.jpg",
          free_shipping: true,
          rating: 3,
          cate_id: 4,
          unit_id: 1,
          categories: [
            {
              id: 4,
              name: "Thuốc",
              icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.996 60"><path fill-rule="evenodd" fill="currentColor" clip-rule="evenodd" d="M57.678,46.264l-9.648-9.648V26.035V26c0-0.004-0.002-0.007-0.002-0.011c-0.012-4.027-1.557-7.838-4.359-10.734 l-0.639-0.661V10h1c0.552,0,1-0.447,1-1V6h-13c-0.552,0-1-0.447-1-1s0.448-1,1-1h13V3c0-1.654-1.346-3-3-3h-36 c-1.654,0-3,1.346-3,3v1h11c0.552,0,1,0.447,1,1s-0.448,1-1,1h-11v3c0,0.553,0.448,1,1,1h1v4.595l-0.639,0.661 C1.59,18.151,0.044,21.962,0.033,25.99c0,0.004-0.002,0.007-0.002,0.011v0.034V48v8c0,2.206,1.794,4,4,4h27h14 c1.267,0,2.461-0.304,3.527-0.83c1.095,0.522,2.269,0.793,3.44,0.793c2.081,0,4.141-0.804,5.681-2.344 C60.809,54.488,60.809,49.394,57.678,46.264z M45.03,44h-8.634c-0.02-0.056-0.045-0.11-0.063-0.167 c-0.415-1.296-0.371-2.74,0.118-4.009c0.89-2.313,3.138-3.821,5.609-3.821c1.554,0,3.108,0.578,4.264,1.733l4.263,4.263 l-2.58,2.581C47.085,44.209,46.082,44,45.03,44z M43.03,33h-22c-0.552,0-1-0.447-1-1s0.448-1,1-1h22c0.552,0,1,0.447,1,1 S43.582,33,43.03,33z M21.03,36h15.71c-0.121,0.106-0.244,0.208-0.358,0.322c-0.278,0.278-0.527,0.576-0.757,0.886 c-0.076,0.102-0.139,0.21-0.209,0.315c-0.106,0.158-0.221,0.312-0.315,0.476h-14.07c-0.552,0-1-0.447-1-1S20.478,36,21.03,36z M21.03,41h13.075c-0.024,0.191-0.031,0.384-0.042,0.577c-0.005,0.102-0.02,0.203-0.021,0.305 c-0.006,0.373,0.013,0.746,0.059,1.118H21.03c-0.552,0-1-0.447-1-1S20.478,41,21.03,41z M18.03,4h10c0.552,0,1,0.447,1,1 s-0.448,1-1,1h-10c-0.552,0-1-0.447-1-1S17.478,4,18.03,4z M41.03,10v4h-34v-4H41.03z M5.828,16.646L6.453,16h35.152l0.626,0.646 c2.208,2.282,3.511,5.217,3.749,8.354H2.079C2.317,21.864,3.62,18.928,5.828,16.646z M6.03,38c-0.552,0-1-0.447-1-1s0.448-1,1-1h4 v-4c0-0.553,0.448-1,1-1s1,0.447,1,1v4h4c0.552,0,1,0.447,1,1s-0.448,1-1,1h-4v4c0,0.553-0.448,1-1,1s-1-0.447-1-1v-4H6.03z M25.744,58H4.03c-1.103,0-2-0.897-2-2v-7c0,0,21.585,0,21.589,0c-0.264,0-0.538,2.071-0.559,2.31 c-0.063,0.723-0.021,1.452,0.116,2.165c0.322,1.663,1.166,3.209,2.404,4.365C25.636,57.892,25.687,57.95,25.744,58z M25.03,52 c0-2.848,2.086-5.315,4.861-5.88C30.84,45.927,31.849,46,32.814,46c0.862,0,1.724,0,2.586,0c0.103,0,0.206,0,0.308,0h1.321v12h-6 C27.721,58,25.03,55.309,25.03,52z M39.03,58V46h6c3.308,0,6,2.691,6,6c0,0.246-0.019,0.489-0.049,0.73 c-0.007,0.055-0.017,0.109-0.025,0.164c-0.031,0.2-0.069,0.399-0.12,0.594c-0.01,0.038-0.019,0.076-0.029,0.114 c-0.136,0.485-0.33,0.952-0.581,1.387c0,0,0,0.001-0.001,0.001c-0.125,0.215-0.264,0.422-0.414,0.621 c-0.01,0.014-0.021,0.027-0.031,0.041c-0.306,0.398-0.664,0.759-1.064,1.073c-0.02,0.016-0.041,0.03-0.061,0.045 c-0.186,0.142-0.381,0.274-0.585,0.394C47.177,57.692,46.14,58,45.03,58H39.03z M56.264,56.205 c-1.517,1.517-3.706,2.083-5.721,1.581c0.011-0.01,0.02-0.022,0.03-0.032c0.168-0.162,0.328-0.333,0.482-0.509 c0.018-0.02,0.036-0.039,0.054-0.059c1.194-1.398,1.92-3.208,1.92-5.186c0-2.617-1.269-4.937-3.217-6.398L52,43.414l4.264,4.264 C58.614,50.028,58.614,53.854,56.264,56.205z"></path></svg>',
              slug: "/thuoc",
              description: "",
            },
          ],
          unit: {
            id: 1,
            name: "Hộp",
          },
          source:
            "https://nhathuoclongchau.com.vn/thuoc/distocide-600mg-3980.html",
          isInWishlist: false,
          isInCart: false,
          count: 6,
        },
      ],
      status: 4,
      created_at: 1688452993419,
      payment_method: 2,
      orderer: {
        name: "Nguyễn Văn A",
        phone: "0975796307",
        province: "",
        address: "Ninh Bình",
      },
      receiver: {
        name: "Nguyễn Văn A",
        phone: "0975796307",
        province: "",
        address: "Ninh Bình",
      },
      isPersonReceiver: true,
    },
    {
      id: "dc3a5df9-d79c-45a4-99b6-c4f7d48a25ff",
      order_id: 367,
      products: [
        {
          id: 9,
          name: "Hỗ trợ chăm sóc tại nhà 24H",
          slug: "ho-tro-cham-soc-tai-nha-24h-9",
          description: "",
          brand: "HODO",
          price: 5000000,
          old_price: 0,
          image:
            "https://api-dev.hodo.app/storage/services/28/banner_web/5160ea4dd7eb92dfd5b7b76110a2d2ff.png",
          free_shipping: true,
          rating: 3,
          cate_id: 2,
          unit_id: 3,
          categories: [
            {
              id: 2,
              name: "Dịch vụ Y tế",
              icon: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19 8L18.9994 8.25C18.3514 8.24838 17.7238 8.47623 17.2278 8.89316C16.7318 9.31009 16.3994 9.88918 16.2896 10.5278C16.1798 11.1664 16.2997 11.8232 16.6279 12.3819C16.9562 12.9405 17.4716 13.3649 18.0829 13.5798L18.25 13.6386V15.5C18.25 16.7598 17.7496 17.968 16.8588 18.8588C15.968 19.7496 14.7598 20.25 13.5 20.25C12.2402 20.25 11.032 19.7496 10.1412 18.8588C9.25045 17.968 8.75 16.7598 8.75 15.5V14.6985L8.95818 14.6632C10.2966 14.4361 11.5117 13.7431 12.3886 12.7067C13.2655 11.6702 13.7477 10.3572 13.75 8.99958V3C13.75 2.80109 13.671 2.61032 13.5303 2.46967C13.3897 2.32902 13.1989 2.25 13 2.25H11C10.8011 2.25 10.6103 2.32902 10.4697 2.46967C10.329 2.61032 10.25 2.80109 10.25 3C10.25 3.19891 10.329 3.38968 10.4697 3.53033C10.6103 3.67098 10.8011 3.75 11 3.75H12.25V9C12.25 10.1272 11.8022 11.2082 11.0052 12.0052C10.2082 12.8022 9.12717 13.25 8 13.25C6.87283 13.25 5.79183 12.8022 4.9948 12.0052C4.19777 11.2082 3.75 10.1272 3.75 9V3.75H5C5.19891 3.75 5.38968 3.67098 5.53033 3.53033C5.67098 3.38968 5.75 3.19891 5.75 3C5.75 2.80109 5.67098 2.61032 5.53033 2.46967C5.38968 2.32902 5.19891 2.25 5 2.25H3C2.80109 2.25 2.61032 2.32902 2.46967 2.46967C2.32902 2.61032 2.25 2.80109 2.25 3V8.99978C2.25235 10.3573 2.73457 11.6703 3.6114 12.7067C4.48828 13.7431 5.70335 14.4361 7.04182 14.6632L7.25 14.6985V15.5C7.25 17.1576 7.90848 18.7473 9.08058 19.9194C10.2527 21.0915 11.8424 21.75 13.5 21.75C15.1576 21.75 16.7473 21.0915 17.9194 19.9194C19.0915 18.7473 19.75 17.1576 19.75 15.5V13.6386L19.9171 13.5799C20.5284 13.365 21.0438 12.9406 21.3721 12.3819C21.7003 11.8232 21.8201 11.1664 21.7103 10.5278C21.6005 9.88921 21.2682 9.31013 20.7722 8.89319C20.2762 8.47625 19.6486 8.24839 19.0006 8.25L19 8ZM19.8835 11.8835C20.1178 11.6492 20.2496 11.3316 20.25 11.0003C20.25 10.7531 20.1767 10.5111 20.0393 10.3055C19.902 10.1 19.7068 9.93976 19.4784 9.84515C19.2499 9.75054 18.9986 9.72579 18.7561 9.77402C18.5137 9.82225 18.2909 9.9413 18.1161 10.1161C17.9413 10.2909 17.8222 10.5137 17.774 10.7561C17.7258 10.9986 17.7505 11.2499 17.8452 11.4784C17.9398 11.7068 18.1 11.902 18.3055 12.0393C18.5111 12.1767 18.7531 12.25 19.0003 12.25C19.3316 12.2496 19.6492 12.1178 19.8835 11.8835Z" fill="currentColor"></path></svg>',
              slug: "/dich-vu-y-te",
              description: "",
            },
          ],
          unit: {
            id: 3,
            name: "Lượt",
          },
          source: "",
          isInWishlist: false,
          isInCart: false,
          count: 1,
        },
      ],
      status: 7,
      created_at: 1688465837756,
      payment_method: 1,
      orderer: {
        name: "Nguyễn Văn A",
        phone: "0975796307",
        province: "",
        address: "Ninh Bình",
      },
      receiver: {
        name: "Phạm Thị B",
        phone: "0975796999",
        province: "",
        address: "Hà Nội",
      },
      isPersonReceiver: false,
    },
    {
      id: "7f2b923f-90d8-4e70-ba8c-6a4ab54b7b66",
      order_id: 369,
      products: [
        {
          id: 2,
          name: "Sữa Nestlé Boost Optimum bổ sung dinh dưỡng cho người lớn (800g)",
          slug: "sua-nestle-boost-optimum-bo-sung-dinh-duong-cho-nguoi-lon-800g-2",
          description:
            "Sữa Nestlé Boost Optimum là công thức dinh dưỡng dành cho người lớn với đạm whey, probiotics (vi sinh vật có lợi), prebiotics (chất xơ inulin) cùng các vitamins và khoáng chất thiết yếu.",
          brand: "NESTLE SUISSE.S.A",
          price: 625000,
          old_price: 679000,
          image: "/img/2.8d0342a7.jpg",
          free_shipping: true,
          rating: 3,
          cate_id: 1,
          unit_id: 1,
          categories: [
            {
              id: 1,
              name: "Sản phẩm",
              icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128"> <path fill-rule="evenodd" fill="currentColor" clip-rule="evenodd" d="M125,28.7l-33.8-12c-0.8-0.3-1.6-0.2-2.3,0.1C87.8,17.3,29,38.1,29,38.1c-1.5,0.5-2.5,1.9-2.5,3.5v14c0,1.3,0.8,2.4,2,2.8 l7.8,2.8c2,0.7,4-0.7,4-2.8V46.7c0-1.6,1-3,2.5-3.5l53.1-18.4l19.2,6.8L63,49.9c0,0,0,0,0,0c-1.1,0.4-2,1.5-2,2.8v60.8L7,94.4V33.6 l58-20.5c1.6-0.6,2.4-2.3,1.8-3.8c-0.6-1.6-2.3-2.4-3.8-1.8L3,28.7c-1.2,0.4-2,1.6-2,2.8v65c0,1.3,0.8,2.4,2,2.8l60,21.2 c0.3,0.1,0.7,0.2,1,0.2c0.2,0,0.3,0,0.5,0c0,0,0.1,0,0.1,0c0.1,0,0.2-0.1,0.4-0.1c0,0,0,0,0,0l60-21.2c1.2-0.4,2-1.6,2-2.8v-65 c0,0,0,0,0,0C127,30.2,126.2,29.1,125,28.7z" ></path></svg>',
              slug: "/san-pham",
              description: "",
            },
          ],
          unit: {
            id: 1,
            name: "Hộp",
          },
          source:
            "https://nhathuoclongchau.com.vn/thuc-pham-chuc-nang/sua-nestle-boost-optimum-800g-33605.html",
          isInWishlist: false,
          isInCart: false,
          count: 1,
        },
        {
          id: 3,
          name: "Sữa FortiCare Nutricia vị Cappuccino dành cho người bệnh ung thư (4 chai x 125ml)",
          slug: "sua-forticare-nutricia-vi-cappuccino-danh-cho-nguoi-benh-ung-thu-4-chai-x-125ml-3",
          description:
            "Forticare vị cappuccino cung cấp các chất dinh dưỡng, vitamin và khoáng chất cần thiết trong các trường họp khó nhai, khó nuốt, cơ thể suy kiệt.",
          brand: "Nutricia",
          price: 388000,
          old_price: 0,
          image: "/img/3.eed13b3b.jpg",
          free_shipping: true,
          rating: 3,
          cate_id: 1,
          unit_id: 1,
          categories: [
            {
              id: 1,
              name: "Sản phẩm",
              icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128"> <path fill-rule="evenodd" fill="currentColor" clip-rule="evenodd" d="M125,28.7l-33.8-12c-0.8-0.3-1.6-0.2-2.3,0.1C87.8,17.3,29,38.1,29,38.1c-1.5,0.5-2.5,1.9-2.5,3.5v14c0,1.3,0.8,2.4,2,2.8 l7.8,2.8c2,0.7,4-0.7,4-2.8V46.7c0-1.6,1-3,2.5-3.5l53.1-18.4l19.2,6.8L63,49.9c0,0,0,0,0,0c-1.1,0.4-2,1.5-2,2.8v60.8L7,94.4V33.6 l58-20.5c1.6-0.6,2.4-2.3,1.8-3.8c-0.6-1.6-2.3-2.4-3.8-1.8L3,28.7c-1.2,0.4-2,1.6-2,2.8v65c0,1.3,0.8,2.4,2,2.8l60,21.2 c0.3,0.1,0.7,0.2,1,0.2c0.2,0,0.3,0,0.5,0c0,0,0.1,0,0.1,0c0.1,0,0.2-0.1,0.4-0.1c0,0,0,0,0,0l60-21.2c1.2-0.4,2-1.6,2-2.8v-65 c0,0,0,0,0,0C127,30.2,126.2,29.1,125,28.7z" ></path></svg>',
              slug: "/san-pham",
              description: "",
            },
          ],
          unit: {
            id: 1,
            name: "Hộp",
          },
          source:
            "https://nhathuoclongchau.com.vn/thuc-pham-chuc-nang/sua-forticare-cappuccino-nutricia-125-ml-x-4-chai.html",
          isInWishlist: false,
          isInCart: false,
          count: 2,
        },
      ],
      status: 1,
      created_at: 1688616577653,
      payment_method: 2,
      orderer: {
        name: "Nguyễn Văn A",
        phone: "0975796307",
        province: "",
        address: "Ninh Bình",
      },
      receiver: {
        name: "Phạm Thị B",
        phone: "0975796999",
        province: "",
        address: "Hà Nội",
      },
      isPersonReceiver: false,
    },
  ],
};

/* eslint-enable */

// ------------------------------------------------
// GET: Return orders
// ------------------------------------------------
mock.onGet("/apps/orders").reply((config) => {
  // eslint-disable-next-line object-curly-newline
  const {
    q = "",
    sortBy = "id",
    sortDesc = false,
    perPage = 9,
    page = 1,
  } = config.params;
  let filteredData = [...db.orders];

  if (q.length && q !== "") {
    const queryLowered = Number(q);

    filteredData = db.orders?.filter(
      (order) => Number(order.order_id) === queryLowered
    );
  }

  const sortByKey = (() => {
    if (sortBy === "price-desc") {
      return "price";
    }
    if (sortBy === "price-asc") {
      return "price";
    }
    return sortBy;
  })();

  const sortedData = filteredData.sort(sortCompare(sortByKey));
  if (sortDesc) sortedData.reverse();

  const paginatedData = JSON.parse(
    JSON.stringify(paginateArray(sortedData, perPage, page))
  );

  return [
    200,
    {
      data: paginatedData,
      total: filteredData.length,
    },
  ];
});

// ------------------------------------------------
// GET: Return Single Order
// ------------------------------------------------
mock.onGet(/\/apps\/orders\/\d+/).reply((config) => {
  // Get product id from URL
  let productId = config.url.substring(config.url.lastIndexOf("/") + 1);

  // Convert Id to number
  productId = Number(productId);

  const productIndex = data.products.findIndex((p) => p.id === productId);
  const product = data.products[productIndex];

  if (product) {
    // Add data of wishlist and cart
    product.isInWishlist =
      data.userWishlist.findIndex((p) => p.productId === product.id) > -1;
    product.isInCart =
      data.userCart.findIndex((p) => p.productId === product.id) > -1;

    // * Add Dummy data for details page
    product.colorOptions = ["primary", "success", "warning", "danger", "info"];

    return [200, { product }];
  }
  return [404];
});
